import { Button, ButtonProps, Group, Loader, Modal, Stack, Text } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import React, { ReactNode, useState } from "react";

export interface ConfirmAbortModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  customHeader?: string;
  customText?: string;
  customButtonText?: string;
  customButtonIcon?: ReactNode | null;
  customButtonVariant?: ButtonProps["variant"];
}

export const ConfirmAbortModal: React.FC<ConfirmAbortModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  customHeader = "Bekreft",
  customText = "Er du sikker på at du vil lukke og miste alle endringer?",
  customButtonText = "Fortsett",
  customButtonIcon = <IconTrash size={16} />,
  customButtonVariant = "danger-filled",
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <Modal opened={isOpen} onClose={onCancel} title={customHeader} centered>
      <Stack gap="md">
        <Text>{customText}</Text>
        <Group justify="space-between">
          <Button variant="outline" onClick={onCancel}>
            Avbryt
          </Button>
          <Button
            leftSection={loading === true ? <Loader color="white" size={16} /> : customButtonIcon}
            variant={customButtonVariant}
            onClick={async () => {
              setLoading(true);
              await onConfirm();
              setLoading(false);
            }}
          >
            {customButtonText}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
